import * as v from 'valibot'

export const cbpgCalculatorSchema = v.object({
  importCountry: v.pipe(
    v.string('Vui lòng chọn quốc gia nhập khẩu'),
    v.minLength(1, 'Vui lòng chọn quốc gia nhập khẩu')
  ),

  importDate: v.pipe(
    v.string('Vui lòng nhập thời gian nhập khẩu'),
    v.minLength(1, 'Vui lòng nhập thời gian nhập khẩu'),
    v.regex(/^\d{4}-\d{2}-\d{2}$/, 'Ngày không hợp lệ')
  ),

  quantity: v.pipe(
    v.number('Vui lòng nhập số lượng'),
    v.minValue(0.0001, 'Số lượng phải lớn hơn 0')
  ),

  unitPrice: v.pipe(
    v.number('Vui lòng nhập đơn giá'),
    v.minValue(0.0001, 'Đơn giá phải lớn hơn 0')
  ),

  currency: v.pipe(
    v.string('Vui lòng chọn loại tiền'),
    v.minLength(1, 'Vui lòng chọn loại tiền')
  ),

  formCOCountry: v.optional(v.string()),

  manufactoringCompany: v.optional(v.string()),

  tradingCompany: v.optional(v.string()),
})

export type CBPGCalculatorFormData = v.InferOutput<typeof cbpgCalculatorSchema>
